import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Form, Grid, Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash/lang';
import {FormErrors} from '../common';
import InitializeAccountProfileForm from './InitializeAccountProfileForm';
import {validateSubscription, activateMySubscription, acceptSubscription} from 'api';
import {formatErrors} from 'actions/errors';
import {setAuthInfo, fetchCurrentAccount, setCurrentAccount, updateProfile, removeAuthInfo} from 'actions/account';
import {isReader} from 'utils/permissions';

class AcceptSubscription extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    removeAuthInfo();
    this.state = {
      token: null,
      user: {},
      subscriptionId: null,
      errors: {},
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.acceptSubscription = this.acceptSubscription.bind(this);
  }

  componentDidMount() {
    const {formatErrors} = this.props;
    validateSubscription()
      .then(({token, user, subscriptionId}) => {
        setAuthInfo(token);
        setCurrentAccount(user);
        let apiCall;
        if (isReader(user.role)) {
          apiCall = () => activateMySubscription(subscriptionId);
        } else {
          apiCall = () => Promise.resolve();
        }
        return apiCall().then(() => {
          this.setState({
            token,
            user,
            subscriptionId,
          });
        });
      })
      .catch((err) => formatErrors(err));
  }

  handleFormSubmit(data) {
    const {
      router: {
        history: {push},
      },
    } = this.context;
    const {updateProfile, formatErrors} = this.props;
    return updateProfile(data)
      .then(({token, user}) => {
        if (isReader(user.role)) {
          push('/');
        } else {
          this.setState({
            token,
            user,
          });
        }
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  acceptSubscription() {
    const {formatErrors} = this.props;
    const {subscriptionId} = this.state;
    const {
      router: {
        history: {push},
      },
    } = this.context;
    acceptSubscription(subscriptionId)
      .then(() => push('/'))
      .catch((err) => formatErrors(err));
  }

  render() {
    const {user, errors} = this.state;
    return isEmpty(user) ? null : (
      <div className="subscription-acceptation">
        <Grid className="content-box">
          {!user.activated ? (
            <Panel>
              <h3>
                <div className="header">Before Accepting Subscription - Complete your account information</div>
              </h3>
              <FormErrors errors={errors} />
              <InitializeAccountProfileForm onSubmit={this.handleFormSubmit} />
            </Panel>
          ) : (
            <Panel>
              <h3 className="section-header">
                <div className="section-title">Accept Subscription</div>
              </h3>
              {isEmpty(user.readers) && (
                <React.Fragment>
                  <p className="flex-row-center">
                    <img alt="Kluwell" src="/images/kluwell-banner.jpg" />
                  </p>
                  <h4 className="flex-row-center">
                    You can accept the subscription now and assign it to your kid's account later.
                  </h4>
                  <br />
                  <Button variant="contained" color="primary" fullWidth onClick={this.acceptSubscription}>
                    Accept Subscription
                  </Button>
                </React.Fragment>
              )}
            </Panel>
          )}
        </Grid>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  setCurrentAccount: (...args) => dispatch(setCurrentAccount(...args)),
  fetchCurrentAccount: (...args) => dispatch(fetchCurrentAccount(...args)),
  updateProfile: (...args) => dispatch(updateProfile(...args)),
});

export default connect(null, mapDispatchToProps)(AcceptSubscription);
